module.exports = __webpack_public_path__ + "img/learnBanner.38815cae.png";